export const taskModalsInitialState = {
  taskModal: null,
}

export const TASK_MODALS_ACTIONS = {
  CREATE_TASK_MODAL: 'CREATE_TASK_MODAL',
  REMOVE_TASK_MODAL: 'REMOVE_TASK_MODAL',
}

export const taskModalsActions = {
  [TASK_MODALS_ACTIONS.CREATE_TASK_MODAL]: (_, { taskModal }) => {
    return { taskModal }
  },

  [TASK_MODALS_ACTIONS.REMOVE_TASK_MODAL]: () => {
    return { taskModal: null }
  },
}
